module.exports = __webpack_public_path__ + "static/media/FTM.c2bd8c1f.png";